import React from 'react';

import { ReportsContainer } from '../../containers';

export const Reports: React.FC = () => <ReportsContainer />;
